import cn from 'clsx'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Chip = styled(LoadingBox)`
  display: inline-flex;
  align-items: center;
  border-radius: ${props => props.theme.borderRadius.round};
  overflow: hidden;

  &.size-small {
    height: ${rem(28)};
    padding: 0 ${rem(8)};
  }

  &.size-medium {
    height: ${rem(32)};
    padding: 0 ${rem(8)};
  }

  &.size-large {
    height: ${rem(36)};
    padding: 0 ${rem(12)};
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  /** Determines factors like the height/padding of the chip */
  size: 'small' | 'medium' | 'large';
}

function LoadingChip(props: Props) {
  const { size, className, ...rest } = props

  return (<Chip
    {...rest}
    className={cn(
      className,
      `size-${size}`,
    )}
  />)
}

export default LoadingChip
